import { render, staticRenderFns } from "./whatsapp-community-modal.vue?vue&type=template&id=27fdd003&scoped=true"
import script from "./whatsapp-community-modal.vue?vue&type=script&lang=js"
export * from "./whatsapp-community-modal.vue?vue&type=script&lang=js"
import style0 from "./whatsapp-community-modal.vue?vue&type=style&index=0&id=27fdd003&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27fdd003",
  null
  
)

export default component.exports